import { UserRole } from '@fp3/shared'
import { useAuthContext } from '../context/useAuthContext'

export const useAuth = () => {
  const ctx = useAuthContext()
  return {
    ...ctx,
    isAdmin: ctx.user?.role === UserRole.ADMIN,
  }
}
